import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GetEnrolledCourses from "../../actions/GetEnrolledCourses";
import LinearProgressWithLabel from "../../components/progress/LinearProgressWithLabel";
import { AuthContext } from "../../context/AuthContext";
import Localbase from "localbase";
import VideoRecommendations from "./VideoRecommendations";
import { Skeleton } from "@mui/material";
import Rating from "@mui/material/Rating";
import GettingStartedDashboard from "../intros/GettingStartedDashboard";
import CoursesList from "../courses/CoursesList";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Box from "@mui/material/Box";
import { Offcanvas, Toast } from "react-bootstrap";
import GetCourses from "../../actions/GetCourses";
import CourseItem from "../courses/CourseItem";
import SliderCourseItem from "../courses/SliderCourseItem";
import SacEvents from "../home/SacEvents";
import PreviewIcon from "@mui/icons-material/ArrowBackIosNew";
import NextIcon from "@mui/icons-material/ArrowForwardIos";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ModalStyle from "../../data/ModalStyle";
import Close from "@mui/icons-material/Close";
import SubmitCourseFeedback from "../../actions/course/SubmitCourseFeedback";

const DashboardCourseProgress = ({ account }) => {
  const { user } = useContext(AuthContext);
  const [mycourses, setmycourses] = useState(null);
  let db = new Localbase("db");

  const NewGetMyCourses = async () => {
    const res = await GetEnrolledCourses({ user, limit: 2 });
    if (res) {
      setloading(false);
      if (res.status === "success") {
        setmycourses(res.data);
        db.collection("paths").add({ my_courses: res.data }, "my_courses");
      }
    }
  };

  const [loading, setloading] = useState(true);

  useEffect(() => {
    db.collection("paths")
      .doc("my_courses")
      .get()
      .then((data) => {
        if (data && data.my_courses) {
          setmycourses(data.my_courses);
        }
      })
      .catch(() => { });
    NewGetMyCourses({ user });
  }, []);

  const NewGetCourses = async () => {
    const res = await GetCourses({ payload: { mode: "live", limit: 4 } });
    if (res) setcourses(res);
  };

  const [courses, setcourses] = useState(null);

  useEffect(() => {
    NewGetCourses();
  }, []);

  var scrollAmount;

  const buttonclick = () => {
    var container = document.getElementById("dash-container");
    sideScroll(container, "right", 15, 300, 10);
  };

  const back = () => {
    var container = document.getElementById("dash-container");
    sideScroll(container, "left", 15, 300, 10);
  };

  function sideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === "left") element.scrollLeft -= step;
      else element.scrollLeft += step;
      scrollAmount += step;
      if (scrollAmount >= distance) window.clearInterval(slideTimer);
    }, speed);
  }

  const [review, setreview] = useState(null);
  const [modal, setmodal] = useState(false);
  const [submitting, setsubmitting] = useState(false);
  const [value, setValue] = useState(0);
  const [currentcourse, setcurrentcourse] = useState(null);
  const [toast, settoast] = useState(false);
  const [toastmessage, settoastmessage] = useState(null);

  const SubmitFeedback = async () => {
    setsubmitting(true);
    const res = await SubmitCourseFeedback({
      payload: {
        session: user.SessionId,
        course_url: currentcourse.course_url,
        batch_id: currentcourse.batch_id,
        review: review,
        rating: value,
      },
    });

    if (res) {
      setsubmitting(false);
      if (res.status === "success") {
        settoastmessage("Course review submitted successfully");
        setmodal(false);
        NewGetMyCourses();
        settoast(true);
      } else {
        settoastmessage("Something went wrong !");
        settoast(true);
      }
    }
  };

  return (
    <>
      <style>{`
        .course-item {
          display: grid;
          grid-template-columns: 280px 1fr;
          background: #fff;
          // border-radius: 22px;
          overflow: hidden;
          margin-bottom: 20px;
          box-shadow: 0 12px 32px rgba(2, 6, 23, 0.15);
          border: 1px solid rgba(2, 6, 23, 0.06);
        }

        .course-img {
          width: 100%;
          height: 100%;
          min-height: 240px;
          object-fit: cover;
        }

        .course-info {
          padding: 26px 28px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 14px;
        }

        .course-title {
          font-size: 1.7rem;
          font-weight: 800;
          color: #0f172a;
          margin: 0;
        }

        .progress-bar-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .progress-label {
          font-weight: 700;
          color: #ff7a18;
          min-width: 48px;
        }

        .continue-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 14px 22px;
          border-radius: 14px;
          background: linear-gradient(135deg, #ff7a18, #ffb347);
          color: #fff;
          font-weight: 800;
          text-decoration: none;
          width: fit-content;
          box-shadow: 0 12px 24px rgba(255, 122, 24, 0.35);
        }

        .continue-link:hover {
          filter: brightness(1.05);
          box-shadow: 0 16px 32px rgba(255, 122, 24, 0.45);
        }

        @media (max-width: 768px) {
          .course-item {
            grid-template-columns: 1fr;
          }
          .course-img {
            min-height: 180px;
          }
          .course-info {
            padding: 18px;
          }
          .course-title {
            font-size: 1.2rem;
          }
          .continue-link {
            width: 100%;
          }
        }
      `}</style>

      <div className="minimal-dash">
        <div className="dash-container">
          {mycourses && mycourses.length > 0 ? (
            <>
              <div className="d-flex mb-3 justify-content-between align-items-center px-3 py-3 rounded-4 flex-wrap"
                style={{
                  background: "#ffffff",
                  boxShadow: "0 8px 22px rgba(2, 6, 23, 0.08)",
                  border: "1px solid rgba(2, 6, 23, 0.06)",
                }}
              >
                {/* Left: Icon + Title */}
                <div className="d-flex align-items-center gap-2">
                  <MenuBookIcon style={{ color: "#ff7a18" }} />
                  <h4
                    className="mb-0"
                    style={{
                      fontWeight: 800,
                      color: "#0f172a",
                      letterSpacing: "-0.3px",
                    }}
                  >
                    My Courses
                  </h4>
                </div>

                {/* Right: Button */}
                <button
                  className="btn btn-sm rounded-pill px-3 py-2"
                  onClick={() => (window.location.href = "/my-courses")}
                  style={{
                    border: "1.5px solid #ff7a18",
                    color: "#ff7a18",
                    background: "transparent",
                    fontWeight: 700,
                    transition: "all .2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(135deg, #ff7a18, #ffb347)";
                    e.currentTarget.style.color = "#fff";
                    e.currentTarget.style.boxShadow =
                      "0 8px 18px rgba(255,122,24,.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "#ff7a18";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  View All
                </button>
              </div>


              <div className="dash-content">
                {mycourses.map((course, idx) => (
                  <div key={idx} className="course-item">
                    <img
                      src={course.course_cover}
                      alt={course.course_title}
                      className="course-img"
                    />
                    <div className="course-info">
                      <h5 className="course-title">{course.course_title}</h5>

                      <div className="progress-bar-wrap">
                        <span className="progress-label">
                          {Math.round(course.progress || 0)}%
                        </span>
                        <div style={{ flex: 1, height: 8, borderRadius: 4, background: 'rgba(246,129,57,0.15)', overflow: 'hidden', marginLeft: 8 }}>
                          <div style={{ height: '100%', width: `${Math.round(course.progress || 0)}%`, background: 'linear-gradient(90deg, #f68139, #ff9960)', borderRadius: 4, transition: 'width 0.5s cubic-bezier(.23,1.01,.32,1)' }}></div>
                        </div>
                      </div>
                      <Link
                        to={`/course-dashboard/${course.course_url}/${course.batch_id}`}
                        className="continue-link"
                        style={{
                          marginTop: 12,
                          color: "#fff",
                          textDecoration: "none"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#fff";
                        }}
                      >
                        Continue Course →
                      </Link>

                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              {loading ? (
                <div className="empty-dash">
                  <div style={{ fontSize: "1.2rem", color: "#ff7a18" }}>
                    Loading...
                  </div>
                </div>
              ) : (
                <div className="empty-dash">
                  <div className="empty-icon">📖</div>
                  <div className="empty-text">
                    <h5>No Courses Yet</h5>
                    <p>Explore and enroll in courses to get started</p>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardCourseProgress;
